/* eslint-disable */
export default {
  monday: 'S',
  tuesday: 'T',
  wednesday: 'W',
  thursday: 'Q',
  friday: 'S',
  saturday: 'S',
  sunday: 'D',
} as const;

// @key: @#@"monday"@#@ @source: @#@"M"@#@
// @key: @#@"tuesday"@#@ @source: @#@"T"@#@
// @key: @#@"wednesday"@#@ @source: @#@"W"@#@
// @key: @#@"thursday"@#@ @source: @#@"T"@#@
// @key: @#@"friday"@#@ @source: @#@"F"@#@
// @key: @#@"saturday"@#@ @source: @#@"S"@#@
// @key: @#@"sunday"@#@ @source: @#@"S"@#@
